import useStyle from "./useStyle"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  loadingOff,
  loadingOn,
  suscribersStatusOrderByDateVESuccess,
} from "../../../../../redux/actions/eventanilla"

function TableHeader() {
  const classes = useStyle()
  const dispatch = useDispatch()
  const { subscribers } = useSelector((state) => state.eventanilla)

  const [order, setorder] = useState("desc")

  const changeOrderByDate = (list) => {
    dispatch(loadingOn())
    dispatch(suscribersStatusOrderByDateVESuccess({ data: list }))
    dispatch(loadingOff())
  }
  const getOrderList = (orderType) => {
    const prop = "lastStatusChangeDate"

    return subscribers.sort((a, b) => {
      const fechaA = new Date(a[prop])
      const fechaB = new Date(b[prop])
      if (fechaA > fechaB) {
        return orderType === "asc" ? 1 : -1
      } else if (fechaA < fechaB) {
        return orderType === "asc" ? -1 : 1
      }
      return 0
    })
  }
  const changeOrderDesc = () => {
    const newOrder = order === "desc" ? "asc" : "desc"
    setorder(newOrder)
    const newList = getOrderList(newOrder)
    changeOrderByDate(newList)
  }

  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCuit}>CUIT</th>
        {/* <th className={classes.headName}>Razón social</th> */}
        <th className={classes.headStatus}>Estado</th>
        <th className={classes.headDate} onClick={changeOrderDesc}>
          Fecha de estado
          {order === "desc" ? (
            <ArrowDownwardIcon style={{ fontSize: 20 }} />
          ) : (
            <ArrowUpwardIcon style={{ fontSize: 20 }} />
          )}
        </th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
